// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2WTRL","dragIcon":"Choice_dragIcon__fgioh","left":"Choice_left__3MrZS","input":"Choice_input__3Nkkf"};